<template>
  <div>
    <h1>Vehicle Deviation</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :dealer_filter="false"
      :item_filter="false"
      :simple_date="true"
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <!-- Vehicle Deviation Table Start -->
    <div class="innerBox mt-5">
      <vehicle-deviation-table
        :filterUrl="filterUrl"
      ></vehicle-deviation-table>
    </div>
    <!-- Vehicle Deviation Table End -->
  </div>
</template>

<script>
  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import vehicleDeviationTable from './children/vehicleDeviationTable'

  export default {
    data () {
      return {
        filterUrl : '',
        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      vehicleDeviationTable,
    },
    mounted () {
      this.fetchFilter++;
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      }
    }
  }
</script>

<style scoped>
  
</style>